import { api } from '../api';
import type { TContextStatuses, TStatuses } from '../models';

export const getVerifySmsApi = (status?: TContextStatuses | TStatuses | null) => {
    if (status === 'NEED_SMS') {
        return {
            verifySmsApi: api.verifySmsFinish,
            requestSmsCodeApi: api.deliveryResendSmsCode,
        };
    }

    return { verifySmsApi: api.verifySms, requestSmsCodeApi: api.requestSmsCode };
};
